<template>
  <div style="height:100%">
    <Header/>
    <router-view/>
    <Footer v-if="isShowFooter"/>
  </div>
</template>

<script>
  import Header from './components/Header'
  import Footer from './components/Footer'

  export default {
    components: {Header, Footer},
    data() {
      return {
        isShowFooter: this.$route.meta.showFooter
      }
    },
    watch: {
      $route: {
        handler() {
          this.isShowFooter = this.$route.meta.showFooter;
        }
      }
    },
  }
</script>

<style scoped>

</style>
